//import api from '../api';
import { newAPIPost } from '../api/index.js';

export default {
    state: {
        stcSMSLog: [],
        searchRequest: null,
      },

      mutations: {
        updatestcSMSLog(state, list) {
          state.stcSMSLog = list;
        },
        updateSearchSTCSMSLogRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },


      actions: {
        async stcSMSLog({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))
          console.log(requestToSend);
          const st = performance.now();
          //const result = await api.post('/api/w/SendSMS/GetRecLog', requestToSend);
          const result = await newAPIPost('/api/w/SendSMS/GetRecLog', requestToSend);
          //const result = await api.post('/api/w/gstMasterData/driverMasterData', drivers = null, transYard = null, defaultSalesOffice = "LGB");
          commit('updateSearchSTCSMSLogRequest', fallbackRequest);
          console.log(JSON.stringify(result));
          return commit('updatestcSMSLog', result);
                },
      },

      getters: {
        getSTCSMSLog: state => state.stcSMSLog,
      },
}